import { t } from "i18next";
import { useEffect } from "react";
import { Localization } from "../locales/schema";

export const DocumentTitle = () => {
  useEffect(() => {
    document.title = t(Localization.Site.Title);
  }, []);
  
  return (<></>);
}